// @flow strict

import * as React from 'react'

import styles from './AccessibilityText.module.scss'

type Props = {
  children: string,
  as?: React.Element<'h1' | 'h2' | 'h3' | 'h4'>,
}

const AccessibilityText = ({ as, children }: Props) => {
  if (as === undefined) {
    return <span className={styles.accessibilityText}>{children}</span>
  }

  return React.cloneElement(
    as,
    { className: styles.accessibilityText },
    children,
  )
}

export default AccessibilityText
